<app-barra-consulta *ngIf="!carregando" visible="false" [listagemComFiltros]="getListagemComFiltros()"
  (atualizando)="atualizar($event)" (inserindo)="novo($event)" (definirFiltro)="definirFiltragem()" [exibirNovo]="false"
  [detalhe]="detalhe">
</app-barra-consulta>
<div class="conteudo">
  <app-loading [exibir]="carregando"></app-loading>
  <div *ngIf="!carregando">
    <div class="row caixa-valores shadow-sm">
      <div class="col col-lg-3 box-individual">
        <div class="spnv01 mt-2 borda-caixa shadow">
          <div [translate]="getTranslate(veiculosVendidos)" class="caption"></div>
          <div class="valor">
            <hr class="divisor">
            <ngx-odometer [number]="quantidadeVeiculoVendido" [config]="configShowNumber"></ngx-odometer>
          </div>
        </div>
      </div>
      <div class="col col-lg-3 box-individual">
        <div class="spnv02 mt-2 borda-caixa shadow">
          <div [translate]="getTranslate(acessoriosVeicVendidos)" class="caption"></div>
          <div class="valor">
            <hr class="divisor">
            <ngx-odometer [number]="spnv" [config]="configShowNumber"></ngx-odometer>
          </div>
        </div>
      </div>
      <div class="col col-lg-3 box-individual">
        <div class="spnv03 mt-2 borda-caixa shadow">
          <div [translate]="getTranslate(pecasVeicVendidos)" class="caption"></div>
          <div class="valor">
            <hr class="divisor">
            <ngx-odometer [number]="spnvPeca" [config]="configShowNumber"></ngx-odometer>
          </div>
        </div>
      </div>
      <div class="col col-lg-3 box-individual">
        <div class="spnv02 mt-2 borda-caixa shadow">
          <div [translate]="getTranslate(clothingVeicVendidos)" class="caption"></div>
          <div class="valor">
            <hr class="divisor">
            <ngx-odometer [number]="spnvClothing" [config]="configShowNumber"></ngx-odometer>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <table class="table table-hover table-striped table-bordered">
        <thead class="thead-dark; border-color: #32383e;">
          <tr style=" color: #fff; background-color: #212529; border-color: #32383e;">
            <th translate>
              {{'pca.resultadoPCA.categoria'}}
            </th>
            <th class="text-right">
              {{marca}}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td translate>{{'pca.resultadoPCA.acessorioBalcao'}}</td>
            <td class="text-right">{{ valorAcessoriosBalcao | number:'1.2-2'}}</td>
          </tr>
          <tr>
            <td translate>{{'pca.resultadoPCA.acessorioOficina'}}</td>
            <td class="text-right">{{ valorAcessoriosServico | number:'1.2-2'}}</td>
          </tr>
          <tr>
            <td translate>{{'pca.resultadoPCA.pecasBalcao'}}</td>
            <td class="text-right">{{ valorPecasBalcao | number:'1.2-2'}}</td>
          </tr>
          <tr>
            <td translate>{{'pca.resultadoPCA.pecasOficinaCliente'}}</td>
            <td class="text-right">{{ valorPecasServico | number:'1.2-2'}}</td>
          </tr>
          <tr>
            <td translate>{{'pca.resultadoPCA.pecasOficinaGarantia'}}</td>
            <td class="text-right">{{ valorGarantia | number:'1.2-2'}}</td>
          </tr>
          <tr>
            <td translate>{{'pca.resultadoPCA.clothing'}}</td>
            <td class="text-right">{{ valorClothing | number:'1.2-2'}}</td>
          </tr>
          <tr style=" color: #fff; background-color: #212529; border-color: #32383e;">
            <td translate>Total</td>
            <td class="text-right">{{ valorTotal | number:'1.2-2'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>